<emm-management-layout>
  <emm-progress-bar [isLoading$]="anyLoading$"></emm-progress-bar>
  <emm-search-filter
    [addDialog]="true"
    [attr.data-testid]="'attribute_groups_search_bar'"
    [fields]="fields"
    [isAdminOrAuthor]="(this.isAdmin || this.isAuthor) && !isMMSAuthor"
    [isSuperAdmin]="this.isSuperAdmin"
    [displaySearchWithOptions]="false"
    [componentName]="'attribute-groups'"
    layout-center-header
    (add)="openCreateAttributeGroupDialog()"
    (filter)="onFilter($event)"
  ></emm-search-filter>
  <emm-generic-items-list
    [items]="attributeGroups$ | async"
    [isReadOnly]="isReadOnly$ | async"
    [contextMenuActions]="attributeGroupsContextMenuActions"
    layout-center-content
    (onSelectItem)="onSelectAttributeGroup($event)"
  ></emm-generic-items-list>
  @if (attributeGroupDetail$ | async; as attributeGroup) {
    <emm-management-attributes-header
      layout-right-header
      [name]="attributeGroup.name"
      [tag]="attributeGroup.id"
    ></emm-management-attributes-header>
  }
  @if (attributeGroupDetail$ | async; as attributeGroup) {
    <emm-management-attribute-groups-form
      #form
      layout-right-content
      [isSuperAdmin]="isSuperAdmin"
      [isAdmin]="isAdmin"
    ></emm-management-attribute-groups-form>
  }
  @if ((attributeGroupDetail$ | async) && !isMMSAuthor) {
    <emm-management-attributes-footer
      [disableCancel]="!attributeGroupsForm || !attributeGroupsForm.hasChanges()"
      [disableUpdate]="!attributeGroupsForm || !attributeGroupsForm.hasChanges()"
      layout-right-footer
      (cancel)="attributeGroupsForm.cancel()"
      (submit)="attributeGroupsForm.submit()"
      class="fixed-row-bottom"
    ></emm-management-attributes-footer>
  }
</emm-management-layout>
